import { Icon } from "@iconify/react";
import Tooltip from "@mui/material/Tooltip";
import documentIconDOC from "../Images/DocumentIconDOC.svg";
import documentIconDefault from "../Images/DocumentIconDefault.svg";
import documentIconPDF from "../Images/DocumentIconPDF.svg";
import documentIconPPT from "../Images/DocumentIconPPT.svg";
import documentIconTXT from "../Images/DocumentIconTXT.svg";
import documentIconXLS from "../Images/DocumentIconXLS.svg";
const APIURL = process.env.REACT_APP_FILE_SERVER_URL;

const renderMessageFB = (
  fileName,
  message,
  type,
  url,
  setIsModalMediaOpen,
  setSelectedMediaType,
  setSelectedMediaURL
) => {
  const textFormatter = (text) => {
    let string = text;

    // html formatter
    const htmlFormat = [
      { symbol: "*", tag: "b" },
      { symbol: "_", tag: "em" },
      { symbol: "~", tag: "del" },
      { symbol: "`", tag: "code" },
    ];

    htmlFormat.forEach(({ symbol, tag }) => {
      if (!string) return;
      const regex = new RegExp(`\\${symbol}[^*]+\\${symbol}`);
      const match = string.match(regex);
      if (!match) return;

      match.forEach((m) => {
        let formatted = m;

        for (let i = 0; i < 2; i++) {
          formatted = formatted.replace(symbol, `<${i > 0 ? "/" : ""}${tag}>`);
        }

        string = string.replace(m, formatted);
      });
    });

    return string;
  };

  const truncateFileName = (fileName) => {
    const NameRegex = /\....*/;
    const tempName = fileName;
    const result = tempName.match(NameRegex);
    const limit = 18;

    return tempName.length > limit
      ? tempName.substring(0, limit) + "..." + result[0]
      : tempName;
  };

  let icon, retval;

  if (type?.includes("application")) {
    // Document
    switch (fileName.substring(fileName.lastIndexOf(".") + 1)) {
      case "pdf":
        icon = documentIconPDF;
        break;

      case "txt":
        icon = documentIconTXT;
        break;

      case "xls":
      case "xlsx":
        icon = documentIconXLS;
        break;

      case "ppt":
      case "pptx":
        icon = documentIconPPT;
        break;

      case "doc":
      case "docx":
        icon = documentIconDOC;
        break;

      default:
        icon = documentIconDefault;
        break;
    }
  }

  // Plain text file
  if (type?.includes("text/plain")) {
    icon = documentIconTXT;
  }

  if (url) {
    return (
      <div>
        {type?.includes("audio") && ( // Audio
          <div className="image-container">
            <audio controls src={`${APIURL}${url}`} />
          </div>
        )}

        {(type?.includes("application") || type?.includes("text/plain")) && ( // Document or plain text
          <>
            <div className="document-container">
              <img src={icon} alt="" className="document-icon" />
              <p className="filename">{truncateFileName(fileName)}</p>

              <a
                className="save-button"
                href={`${APIURL}${url}`}
                rel="noopener noreferrer"
                target="_blank"
              >
                <Tooltip title="Save" arrow>
                  <Icon
                    color="#727272"
                    height="26"
                    icon="ic:baseline-download"
                  />
                </Tooltip>
              </a>
            </div>
          </>
        )}

        {type?.includes("image") && ( // Image
          <div className="image-container">
            <img
              src={`${APIURL}${url}`}
              alt=""
              onClick={() => {
                setIsModalMediaOpen(true);
                setSelectedMediaType(type);
                setSelectedMediaURL(url);
              }}
              className="image"
            />

            <a
              className="save-button"
              download
              href={`${APIURL}${url}`}
              rel="noopener noreferrer"
              target="_blank"
            >
              <Tooltip title="Save" arrow>
                <Icon color="#fff" height="30" icon="ic:baseline-download" />
              </Tooltip>
            </a>
          </div>
        )}

        {type?.includes("video") && ( // Video
          <div className="image-container">
            <video
              className="image"
              controls
              onClick={() => {
                setIsModalMediaOpen(true);
                setSelectedMediaType(type);
                setSelectedMediaURL(url);
              }}
            >
              <source src={`${APIURL}${url}`} />
            </video>
          </div>
        )}
      </div>
    );
  } else {
    retval = textFormatter(type === "template" ? "Template message" : message);
  }

  return (
    <div
      dangerouslySetInnerHTML={{ __html: retval }}
      style={{ whiteSpace: "pre-wrap" }}
    />
  );
};

export default renderMessageFB;
